import { render, staticRenderFns } from "./AddSubClient.vue?vue&type=template&id=2f99f313&scoped=true&"
import script from "./AddSubClient.vue?vue&type=script&lang=js&"
export * from "./AddSubClient.vue?vue&type=script&lang=js&"
import style0 from "./AddSubClient.vue?vue&type=style&index=0&id=2f99f313&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f99f313",
  null
  
)

export default component.exports